import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginApiResponse, LoginRequest, LoginResponse } from '../models/auth.models';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  login(payload: LoginRequest, rememberMe: boolean): Observable<LoginApiResponse> {
    return this.http.post<LoginApiResponse>(`${this.apiUrl}/auth/login`, payload).pipe(
      tap((response) => {
        if (response.data) {
          this.storeSession(response.data, rememberMe);
        }
      }),
    );
  }

  logout(): void {
    localStorage.removeItem('nrpc_access_token');
    localStorage.removeItem('nrpc_user_name');
    localStorage.removeItem('nrpc_login_id');
    localStorage.removeItem('token');
    sessionStorage.removeItem('nrpc_access_token');
    sessionStorage.removeItem('nrpc_user_name');
    sessionStorage.removeItem('nrpc_login_id');
    sessionStorage.removeItem('token');
  }

  isAuthenticated(): boolean {
    return Boolean(this.getToken());
  }

  getToken(): string | null {
    return localStorage.getItem('nrpc_access_token')
      ?? localStorage.getItem('token')
      ?? sessionStorage.getItem('nrpc_access_token')
      ?? sessionStorage.getItem('token');
  }

  getUserName(): string | null {
    return localStorage.getItem('nrpc_user_name') ?? sessionStorage.getItem('nrpc_user_name');
  }

  private storeSession(data: LoginResponse, rememberMe: boolean): void {
    const storage = rememberMe ? localStorage : sessionStorage;
    const otherStorage = rememberMe ? sessionStorage : localStorage;

    otherStorage.removeItem('nrpc_access_token');
    otherStorage.removeItem('nrpc_user_name');
    otherStorage.removeItem('nrpc_login_id');
    otherStorage.removeItem('token');

    storage.setItem('nrpc_access_token', data.access_token);
    storage.setItem('token', data.access_token);
    storage.setItem('nrpc_user_name', data.user_name);
    storage.setItem('nrpc_login_id', String(data.login_id));
  }
}
